import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { GetSubscriptionSetData } from "../../../../Api/ServiceDatas";
import { useApi } from "../../../../hooks/useApi";
import { ICommentInfo } from "../../../../pages/Users/Comment";
import LineBtn from "../../../Button/LineBtn";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import CommentModal from "./CommentModal/CommentModal";
import { atom, useRecoilState, useSetRecoilState } from "recoil";
import { getEllipsis } from "../../../../ApiTS/ApiCommonTS";
import { useNavigate } from "react-router-dom";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import Blank from "../../../DefaultStyles/Blank";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";

interface UserDetailCommentProps {
  userId?: string;
}

export const userCommentDataState = atom<null | ICommentInfo[]>({
  key: "userCommentDataState",
  default: null,
});

export const userCommentListState = atom<ICommentInfo[]>({
  key: "userCommentListState",
  default: [],
});

export default function UserDetailComment({ userId }: UserDetailCommentProps) {
  const navigate = useNavigate();

  const setUserCommentData = useSetRecoilState(userCommentDataState);
  const [page, setPage] = useState(0);
  const [commentModal, setCommentModal] = useState(false);
  const [commentList, setCommentList] = useRecoilState(userCommentListState);
  const [commentData, setCommentData] = useState<ICommentInfo>({
    commentId: "",
    servsubsid: 0,
    partyId: "",
    tag: "",
    content: "",
    writeDay: "",
    writer: "",
    name: "",
    nickname: "",
    uid: "",
  });

  const { response, fetchData } = useApi({
    method: "get",
    url: `comment?page=${page}&size=5&uid=${userId}`,
  });

  const commentInfoHeader = [
    "NO",
    "Subs_name",
    "PID",
    "태그(구분)",
    "내용",
    "작성 일시",
    "작성자",
    "보기",
  ];

  useEffect(() => {
    if (response?.status === 200) {
      const data = response?.data?.items;
      const forcedLeaveOrExit: ICommentInfo[] = [];

      data?.forEach((d: ICommentInfo) => {
        if (d.tag?.includes("파티탈퇴_") || d.tag?.includes("파티해산_")) {
          forcedLeaveOrExit.push(d);
        }
      });

      setCommentList(data);
      setUserCommentData(forcedLeaveOrExit);
    }
  }, [response, userId]);

  useEffect(() => {}, [commentList]);

  return (
    <>
      {commentList?.length > 0 && (
        <>
          <LineBox>
            <>
              <TitleWithLine title="코멘트" />

              <Blank blankHeight={24} />

              <Table tableHeadData={commentInfoHeader}>
                <>
                  {commentList?.map((d: ICommentInfo) => {
                    return (
                      <TableBody key={d?.commentId}>
                        <TableBodyItem>{d?.commentId}</TableBodyItem>
                        <TableBodyItem>
                          {d?.servsubsid && d?.servsubsid > 0
                            ? getSubsNameBySubsId3(d?.servsubsid ?? 0) ?? "-"
                            : "-"}
                        </TableBodyItem>
                        <TableBodyItem
                          clickable={
                            d?.partyId && d?.partyId !== "0" ? true : false
                          }
                          onClick={() => {
                            if (d?.partyId && d?.partyId !== "0") {
                              navigate(`/party/info/${d?.partyId}`);
                            }
                          }}
                        >
                          {d?.partyId === "0" ? "-" : d?.partyId ?? "-"}
                        </TableBodyItem>
                        <TableBodyItem>{d?.tag}</TableBodyItem>
                        <TableBodyItem>
                          {getEllipsis(d?.content!, 18)}
                        </TableBodyItem>
                        <TableBodyItem>
                          {dayjs(d?.writeDay)?.format("YYYY-MM-DD HH:mm")}
                        </TableBodyItem>
                        <TableBodyItem>{d?.writer}</TableBodyItem>
                        <TableBodyItem>
                          <LineBtn
                            btnText="보기"
                            btnClickEvent={() => {
                              setCommentData(d);
                              setCommentModal(true);
                            }}
                          />
                        </TableBodyItem>
                      </TableBody>
                    );
                  })}
                </>
              </Table>

              <Pagination
                totalPage={response?.data?.totalPage ?? 3}
                currentPage={page}
                pageClickEvent={(index) => setPage(index)}
              />
            </>
          </LineBox>

          <Blank blankHeight={20} />

          {commentModal && (
            <CommentModal
              closeEvent={() => setCommentModal(false)}
              confirmEvent={() =>
                fetchData({
                  method: "get",
                  url: `comment?page=${page}&size=5&uid=${userId}`,
                })
              }
              commentData={commentData}
              type="view"
            />
          )}
        </>
      )}
    </>
  );
}
